import React, { FC, PropsWithChildren } from 'react'
import Row from '@amzn/meridian/row'

export interface IMenuSheetOptionProps {
    /**
     * The function to be called upon clicking the option.
     *
     * @type {React.MouseEventHandler<HTMLButtonElement>}
     */
    onClick: () => void
}

export const MenuSheetOption: FC<PropsWithChildren<IMenuSheetOptionProps>> = (props: PropsWithChildren<IMenuSheetOptionProps>) => {
    return (
        <div onClick={props.onClick} style={{ cursor: 'pointer', width: '100%', padding: '14px 16px' }}>
            <Row alignmentHorizontal="left">
                {props.children}
            </Row>
        </div>
    )
}
